import React from 'react';

type ModalViewProps = {
  id: string;
  title?: React.ReactNode;
  body?: React.ReactNode;
  onClose?: () => void;
  closeButtonLabel?: string;
  onInfo?: () => void;
  infoButtonLabel?: string;
  onDelete?: () => void;
  deleteButtonLabel?: string;
  onSave?: () => void;
  saveButtonLabel?: React.ReactNode;
  disable?: boolean;
  disableSave?: boolean;
  size?: 'sm' | 'lg' | '';
};

export const ModalView = ({
  id,
  title,
  body,
  closeButtonLabel,
  onClose,
  infoButtonLabel,
  onInfo,
  deleteButtonLabel,
  onDelete,
  saveButtonLabel,
  onSave,
  disable,
  disableSave,
  size = '',
}: ModalViewProps) => {
  return (
    <div className="modal fade" tabIndex={-1} role="dialog" id={id}>
      <div className={`modal-dialog modal-${size}`} role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => onClose?.()}
              aria-label="Close"
            >
              {closeButtonLabel ?? <span aria-hidden="true">&times;</span>}
            </button>
            {title}
          </div>
          <div className="modal-body">{body}</div>
          <div className="modal-footer">
            {onInfo && (
              <button
                type="button"
                className="btn btn-info"
                onClick={() => onInfo()}
                disabled={disable}
                data-dismiss="modal"
              >
                {infoButtonLabel ?? (
                  <span className="glyphicon glyphicon-info-sign" />
                )}
              </button>
            )}
            {onDelete && !disable && (
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => onDelete()}
                data-dismiss="modal"
              >
                {deleteButtonLabel ?? (
                  <span className="glyphicon glyphicon-trash" />
                )}
              </button>
            )}
            {onSave && (
              <button
                type="button"
                className="btn btn-success"
                data-dismiss="modal"
                disabled={disable || disableSave}
                onClick={() => onSave()}
              >
                {saveButtonLabel ?? <span>返回</span>}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
